import React, {memo} from "react";
import {Link} from "react-router-dom";
import {FrontendRoutes} from "../../constants";

const NavButton = ({label, curVideoType, buttonVideoType}) => {
    return (<span className={`yellow-md-button ${curVideoType === buttonVideoType ? 'active' : ''}`}>
        <Link to={FrontendRoutes.BALLROOM(buttonVideoType)}>
            {label}
        </Link>
    </span>);
}

export default memo(NavButton);